// AI-translated Spanish glossary (generated by backend/scripts/translate_glossary.py). Keyed by slug; `aliases` = extra Spanish spellings used by the guide translations.
export const GLOSSARY_ES = {
  "facp": {
    "term": "Panel de control de alarma contra incendios (FACP)",
    "definition": "El cerebro del sistema: alimenta y supervisa circuitos, recibe señales de los dispositivos iniciadores, determina si se trata de una condición de alarma, falla o supervisión, activa los aparatos de notificación y las funciones de control de emergencia, e informa a la estación supervisora.",
    "nfpa": "Capítulo 10 (Fundamentos) y Capítulo 23 (Sistemas de instalaciones protegidas)",
    "topic": "Fundamentos"
  },
  "idc": {
    "term": "Circuito de dispositivos iniciadores (IDC)",
    "definition": "Circuito convencional que conecta los dispositivos iniciadores (estaciones manuales, detectores de humo y calor, interruptores de flujo de agua) al panel. Los dispositivos simplemente cierran o cambian el estado del circuito; el panel sabe que una zona está en alarma, pero no qué dispositivo la activó. Se supervisa con un dispositivo de fin de línea.",
    "nfpa": "Capítulo 12 (Circuitos y vías de comunicación), Capítulo 23",
    "topic": "Circuitos y energía"
  },
  "nac": {
    "term": "Circuito de aparatos de notificación (NAC)",
    "definition": "Circuito que alimenta sirenas, luces estroboscópicas, altavoces y campanas. Normalmente se mantiene con polaridad inversa para su supervisión y cambia a polaridad de alarma (o transmite audio) cuando el panel entra en alarma. Se dimensiona según la caída de tensión y la corriente total de los aparatos.",
    "nfpa": "Capítulo 12, Capítulo 18 (Aparatos de notificación)",
    "topic": "Circuitos y energía"
  },
  "slc": {
    "term": "Circuito de línea de señalización (SLC)",
    "definition": "Bucle de datos direccionable de un sistema analógico/direccionable. Cada detector, módulo y estación manual tiene una dirección, por lo que el panel sabe exactamente qué dispositivo está en alarma y puede leer los valores de sensibilidad al humo. Los aisladores limitan los efectos de un cortocircuito.",
    "nfpa": "Capítulo 12, Capítulo 23",
    "topic": "Circuitos y energía"
  },
  "eol": {
    "term": "Dispositivo de fin de línea (EOL)",
    "definition": "Resistor (o diodo/condensador) instalado en el extremo eléctrico de un circuito Clase B. El panel mide la pequeña corriente de supervisión que lo atraviesa; una apertura interrumpe la corriente (falla), mientras que un cortocircuito la aumenta (alarma o falla, según el tipo de circuito).",
    "nfpa": "Capítulo 12 (supervisión de vías de comunicación Clase B)",
    "topic": "Pruebas e inspección",
    "aliases": [
      "resistencia de fin de línea",
      "dispositivo de fin de línea",
      "fin de línea"
    ]
  },
  "class-a": {
    "term": "Vía de comunicación Clase A",
    "definition": "Circuito con una ruta de retorno redundante al panel. Una sola apertura o falla a tierra no impide que funcionen los dispositivos ubicados después de la falla, y el panel indica una falla. Requiere más cable, pero mantiene el sistema en funcionamiento ante una sola falla.",
    "nfpa": "12.3.1",
    "topic": "Circuitos y energía"
  },
  "class-b": {
    "term": "Vía de comunicación Clase B",
    "definition": "Circuito que termina en un dispositivo de fin de línea y no tiene una ruta de retorno. Una sola apertura impide que los dispositivos ubicados después de la interrupción reporten; el panel detecta la falla y la indica. Es la clase de vía de comunicación más común y de menor costo.",
    "nfpa": "12.3.2",
    "topic": "Circuitos y energía"
  },
  "class-x": {
    "term": "Vía de comunicación Clase X",
    "definition": "Vía de comunicación Clase A con aislamiento adicional para que un solo cortocircuito tampoco desactive el bucle. Es común en circuitos SLC de aplicaciones de alto valor o edificios de gran altura.",
    "nfpa": "12.3.6",
    "topic": "Circuitos y energía"
  },
  "class-n": {
    "term": "Vía de comunicación Clase N",
    "definition": "Clase de vía de comunicación para sistemas basados en redes (IP/Ethernet), con rutas de comunicación redundantes y enlaces supervisados. Se introdujo para comunicaciones de emergencia y paneles conectados en red.",
    "nfpa": "12.3.7",
    "topic": "Circuitos y energía"
  },
  "ground-fault": {
    "term": "Falla a tierra",
    "definition": "Conexión no intencional entre un conductor del circuito y tierra, generalmente causada por aislamiento dañado, humedad o un cable aplastado. Los paneles la supervisan e indican una falla; dos fallas a tierra en conductores opuestos se convierten en un cortocircuito.",
    "nfpa": "10.6.9 (detección de fallas a tierra), 12.6",
    "topic": "Pruebas e inspección",
    "aliases": [
      "falla a tierra",
      "fallo a tierra"
    ]
  },
  "supervisory-signal": {
    "term": "Señal de supervisión",
    "definition": "Señal que indica que algo que afecta al sistema de protección contra incendios requiere atención, pero no se trata de un incendio; por ejemplo, una válvula de rociadores cerrada, baja presión de aire o un detector de ducto deshabilitado. Es distinta de las señales de alarma y de falla.",
    "nfpa": "3.3 (definiciones), 10.7, 10.15",
    "topic": "Códigos y normas",
    "aliases": [
      "señal de supervisión",
      "señal supervisora"
    ]
  },
  "trouble-signal": {
    "term": "Señal de falla",
    "definition": "Señal que indica una falla en el sistema o en sus vías de comunicación: circuito abierto, falla a tierra, batería baja, pérdida de alimentación de CA o falla de comunicación. Debe indicarse en un plazo de 200 segundos y es distinta de las señales de alarma y de supervisión.",
    "nfpa": "10.15",
    "topic": "Pruebas e inspección",
    "aliases": [
      "señal de falla",
      "señal de avería",
      "señal de problema"
    ]
  },
  "alarm-signal": {
    "term": "Señal de alarma",
    "definition": "Señal que indica una emergencia que requiere acción inmediata, como un incendio. Tiene prioridad sobre las señales de supervisión y de falla, y activa los dispositivos de notificación y las funciones de control de emergencia.",
    "nfpa": "10.7 (prioridad de las señales)",
    "topic": "Códigos y normas",
    "aliases": [
      "señal de alarma"
    ]
  },
  "candela": {
    "term": "Candela (cd)",
    "definition": "Unidad de intensidad luminosa utilizada para clasificar los dispositivos de notificación visual (luces estroboscópicas). Las tablas de NFPA 72 indican la candela requerida según el tamaño del recinto y la altura de montaje para alertar a los ocupantes con pérdida auditiva.",
    "nfpa": "18.5 (características visuales), Tablas 18.5.5.4.1(a)/(b)",
    "topic": "Diseño"
  },
  "dba": {
    "term": "Decibel ponderado A (dBA)",
    "definition": "Nivel sonoro medido con la curva de ponderación A, que se aproxima a la audición humana. Las señales audibles en modo público deben estar al menos 15 dBA por encima del nivel ambiental promedio o 5 dBA por encima del nivel sonoro máximo de 60 segundos, lo que sea mayor.",
    "nfpa": "18.4.4 (requisitos audibles para modo público)",
    "topic": "Diseño"
  },
  "temporal-3": {
    "term": "Patrón Temporal-Three",
    "definition": "La señal de evacuación estándar: tres pulsos de medio segundo, una pausa de 1.5 segundos y repetición. Es obligatorio para las señales de evacuación por alarma de incendio para que los ocupantes reconozcan el mismo patrón en todas partes.",
    "nfpa": "18.4.2.1, ANSI/ASA S3.41",
    "topic": "Códigos y normas"
  },
  "temporal-4": {
    "term": "Patrón Temporal-Four",
    "definition": "Patrón de señal de alarma de monóxido de carbono de cuatro pulsos, utilizado para distinguir las alarmas de CO de las señales de evacuación por incendio.",
    "nfpa": "18.4.2.2, antecedente de NFPA 720",
    "topic": "Códigos y normas"
  },
  "spot-smoke-detector": {
    "term": "Detector de humo puntual",
    "definition": "Detector que detecta humo en un solo punto mediante detección por ionización o fotoeléctrica. La separación nominal es de 30 ft (9.1 m) en cielos rasos lisos; se reduce en presencia de vigas, pendientes y corrientes de aire.",
    "nfpa": "17.7.3 (separación), 17.7.6",
    "topic": "Detección",
    "aliases": [
      "detector de humo puntual",
      "detectores de humo"
    ]
  },
  "heat-detector": {
    "term": "Detector de calor",
    "definition": "Detector que responde a la temperatura: de temperatura fija, de tasa de aumento o compensado por tasa de aumento. Se utiliza donde los detectores de humo podrían generar falsas alarmas (cocinas, garajes y áreas polvorientas). La separación indicada en el listado se reduce en cielos rasos altos.",
    "nfpa": "17.6",
    "topic": "Detección",
    "aliases": [
      "detector de calor",
      "detectores de calor"
    ]
  },
  "duct-detector": {
    "term": "Detector de humo para ductos",
    "definition": "Detector de humo que toma muestras del aire dentro de los ductos de HVAC para apagar las unidades de tratamiento de aire y evitar la circulación del humo. Requiere un dispositivo remoto de prueba/indicador cuando la carcasa no está a la vista.",
    "nfpa": "17.7.5, NFPA 90A",
    "topic": "Detección"
  },
  "beam-detector": {
    "term": "Detector de humo de haz proyectado",
    "definition": "Par de transmisor y receptor (o reflector) que detecta el humo que obstruye un haz de luz a través de un espacio amplio y abierto, como un atrio o un almacén.",
    "nfpa": "17.7.3.7",
    "topic": "Detección"
  },
  "pull-station": {
    "term": "Estación manual de alarma de incendio (estación manual)",
    "definition": "Dispositivo iniciador de accionamiento manual. Se requiere a menos de 5 ft de cada puerta de salida en cada piso, montado a una altura de 42–48 in hasta la manija, y la distancia de recorrido no debe exceder 200 ft en ningún piso.",
    "nfpa": "17.15",
    "topic": "Diseño",
    "aliases": [
      "estación manual",
      "estación de tiro"
    ]
  },
  "waterflow-switch": {
    "term": "Interruptor de flujo de agua",
    "definition": "Interruptor de paleta o de presión instalado en la tubería vertical de rociadores que inicia una alarma cuando fluye agua. Incluye un retardo para evitar activaciones por sobrepresiones; la alarma debe iniciarse dentro de los 90 segundos posteriores al flujo.",
    "nfpa": "17.13.2",
    "topic": "Pruebas e inspección",
    "aliases": [
      "interruptor de flujo de agua",
      "detector de flujo de agua"
    ]
  },
  "tamper-switch": {
    "term": "Interruptor de supervisión de válvula (tamper)",
    "definition": "Interruptor que envía una señal de supervisión cuando una válvula de control de rociadores se mueve de la posición completamente abierta, para que una válvula cerrada nunca pase inadvertida.",
    "nfpa": "17.16",
    "topic": "Pruebas e inspección",
    "aliases": [
      "interruptor de supervisión de válvula",
      "interruptor tamper",
      "interruptor de sabotaje"
    ]
  },
  "secondary-power": {
    "term": "Fuente de alimentación secundaria",
    "definition": "Baterías (o generador) que mantienen el sistema en funcionamiento cuando falla la alimentación primaria de CA: 24 horas en espera seguidas de 5 minutos en alarma para la mayoría de los sistemas, y 15 minutos en alarma para los sistemas de voz de emergencia.",
    "nfpa": "10.6.7",
    "topic": "Diseño",
    "aliases": [
      "alimentación secundaria",
      "fuente de alimentación secundaria",
      "energía secundaria"
    ]
  },
  "standby-current": {
    "term": "Corriente de espera (supervisora)",
    "definition": "Corriente consumida por el panel y todos los dispositivos conectados en condiciones normales, sin alarma. Se multiplica por las horas de espera en el cálculo de baterías.",
    "nfpa": "10.6.7.2",
    "topic": "Diseño",
    "aliases": [
      "corriente en reposo",
      "corriente de reposo",
      "corriente de espera"
    ]
  },
  "alarm-current": {
    "term": "Corriente de alarma",
    "definition": "Corriente consumida cuando todos los aparatos de notificación y relés están activos. Se multiplica por los minutos de alarma (como fracción de una hora) en el cálculo de baterías y se utiliza para dimensionar la caída de tensión del circuito de aparatos de notificación (NAC).",
    "nfpa": "10.6.7.2, 18.3",
    "topic": "Diseño",
    "aliases": [
      "corriente de alarma"
    ]
  },
  "voltage-drop": {
    "term": "Caída de tensión",
    "definition": "Pérdida de tensión a lo largo de un conductor debido a su resistencia. En un NAC, el último aparato debe seguir recibiendo su tensión nominal mínima (a menudo 16 V en un sistema de 24 V) al final de la vida útil de las baterías.",
    "nfpa": "18.3 (funcionamiento de los aparatos), certificación del fabricante",
    "topic": "Circuitos y energía",
    "aliases": [
      "caída de voltaje"
    ]
  },
  "end-of-line-voltage": {
    "term": "Tensión al final de línea",
    "definition": "La tensión medida en el último aparato de un NAC con la carga total de alarma. Es el valor práctico para determinar si se aprueba o no un cálculo de caída de tensión.",
    "nfpa": "18.3, datos del fabricante",
    "topic": "Circuitos y energía",
    "aliases": [
      "voltaje al final de línea",
      "voltaje de fin de línea",
      "tensión de fin de línea"
    ]
  },
  "supervising-station": {
    "term": "Estación de supervisión",
    "definition": "Instalación que recibe señales de las instalaciones protegidas y despacha una respuesta: una estación central, propia o remota de supervisión. Requiere dos vías de comunicación o una sola vía que cumpla criterios de desempeño específicos.",
    "nfpa": "Chapter 26",
    "topic": "Códigos y normas",
    "aliases": [
      "estación supervisora",
      "estación de supervisión"
    ]
  },
  "dact": {
    "term": "Transmisor digital de comunicador de alarmas",
    "definition": "El marcador que envía señales de alarma, supervisión y falla a la estación de supervisión a través de líneas telefónicas o, cada vez más, de comunicadores celulares/IP. Debe probar su vía de comunicación al menos cada 6 horas (24 h para algunas configuraciones).",
    "nfpa": "26.6.3",
    "topic": "Códigos y normas"
  },
  "ahj": {
    "term": "Autoridad competente (AHJ)",
    "definition": "La organización, oficina o persona responsable de hacer cumplir el código y aprobar los equipos y las instalaciones; normalmente, el jefe de bomberos o el funcionario de obras. Rigen la edición adoptada y sus enmiendas.",
    "nfpa": "3.2.2",
    "topic": "Códigos y normas"
  },
  "record-of-completion": {
    "term": "Registro de finalización",
    "definition": "Formulario de NFPA 72 que documenta el sistema instalado, sus componentes, circuitos, fuentes de alimentación y resultados de las pruebas. Se completa durante la aceptación y se conserva en el sitio.",
    "nfpa": "7.5.6, Figure 7.8.2(a)",
    "topic": "Pruebas e inspección",
    "aliases": [
      "registro de finalización",
      "acta de finalización"
    ]
  },
  "acceptance-test": {
    "term": "Prueba de aceptación",
    "definition": "Prueba funcional del 100 por ciento de cada dispositivo y función, presenciada por la autoridad competente, antes de poner en servicio un sistema nuevo o modificado.",
    "nfpa": "14.4.1, Chapter 7",
    "topic": "Pruebas e inspección",
    "aliases": [
      "prueba de aceptación",
      "pruebas de aceptación"
    ]
  },
  "sensitivity-test": {
    "term": "Prueba de sensibilidad del detector de humo",
    "definition": "Verificación de que la respuesta de un detector de humo se encuentra dentro de su rango de sensibilidad certificado, mediante un método de prueba calibrado, los valores analógicos del panel o un instrumento de prueba certificado. Se requiere dentro del primer año de la instalación y, luego, cada dos años.",
    "nfpa": "14.4.4.3",
    "topic": "Pruebas e inspección"
  },
  "impairment": {
    "term": "Inoperatividad",
    "definition": "Condición en la que un sistema de protección contra incendios, o parte de este, está fuera de servicio. Requiere notificar a la autoridad competente (AHJ), a la estación de supervisión y a los ocupantes del edificio, y colocar una etiqueta en el panel hasta que se restablezca el sistema.",
    "nfpa": "10.21",
    "topic": "Pruebas e inspección",
    "aliases": [
      "deterioro",
      "fuera de servicio"
    ]
  },
  "elevator-recall": {
    "term": "Retorno de elevadores",
    "definition": "Función de control de emergencia que devuelve los elevadores al nivel designado (o a un nivel alternativo si el detector del vestíbulo está en alarma) cuando se activan detectores de humo en vestíbulos, cuartos de máquinas o cubos de los elevadores.",
    "nfpa": "21.3, ASME A17.1",
    "topic": "Diseño",
    "aliases": [
      "llamada de ascensores",
      "recuperación de ascensores",
      "retorno de ascensores"
    ]
  },
  "ecs": {
    "term": "Sistema de comunicaciones de emergencia",
    "definition": "Sistema que proporciona instrucciones de voz o texto para emergencias: sistemas de comunicaciones de voz/alarma de emergencia en edificios (EVACS) y sistemas de notificación masiva (MNS).",
    "nfpa": "Capítulo 24",
    "topic": "Fundamentos"
  },
  "intelligibility": {
    "term": "Inteligibilidad",
    "definition": "Qué tan claramente se pueden entender los mensajes de voz, medido mediante STI/CIS. Los sistemas de voz deben ser inteligibles en espacios acústicamente diferenciables, no simplemente tener un volumen alto.",
    "nfpa": "18.4.11, Anexo D",
    "topic": "Diseño",
    "aliases": [
      "inteligibilidad"
    ]
  },
  "isolator-module": {
    "term": "Módulo aislador",
    "definition": "Dispositivo del circuito de línea de señalización (SLC) que abre el circuito a ambos lados de un cortocircuito para que el resto del circuito direccionable siga funcionando. Se requiere para cumplir con la Clase X y suele utilizarse para limitar la cantidad de dispositivos que se pierden debido a una falla.",
    "nfpa": "12.3, 23.6.1",
    "topic": "Circuitos y energía",
    "aliases": [
      "módulo aislador"
    ]
  },
  "monitor-module": {
    "term": "Módulo de monitoreo (entrada)",
    "definition": "Módulo direccionable que conecta un contacto convencional —como un interruptor de flujo de agua, un interruptor de supervisión de válvula o una estación manual de alarma— al SLC con su propia dirección.",
    "nfpa": "Capítulo 23, certificación del fabricante",
    "topic": "Fundamentos",
    "aliases": [
      "módulo monitor",
      "módulo de monitoreo",
      "módulo de entrada"
    ]
  },
  "relay-module": {
    "term": "Módulo de relé (control)",
    "definition": "Módulo direccionable con contactos secos que el panel acciona para controlar puertas, ventiladores, elevadores u otros equipos como parte de la secuencia de operación.",
    "nfpa": "Capítulo 21, Capítulo 23",
    "topic": "Fundamentos",
    "aliases": [
      "módulo de relé",
      "módulo de control"
    ]
  },
  "plenum-cable": {
    "term": "Cable con clasificación para plénum (FPLP)",
    "definition": "Cable de alarma contra incendios de potencia limitada, certificado para uso en ductos, plénums y otros espacios de manejo de aire debido a su baja emisión de humo y propagación de la llama. FPLR es para montantes y FPL para uso general.",
    "nfpa": "NFPA 70 Article 760",
    "topic": "Circuitos y energía"
  },
  "power-limited": {
    "term": "Circuito de alarma contra incendios de potencia limitada",
    "definition": "Circuito de alarma contra incendios alimentado por una fuente certificada de potencia limitada, que permite utilizar métodos de cableado y tipos de cable de menor tamaño conforme a la Parte III del NEC Article 760.",
    "nfpa": "NFPA 70 760.121",
    "topic": "Circuitos y energía"
  },
  "sequence-of-operations": {
    "term": "Secuencia de operaciones",
    "definition": "Matriz que define qué acción de cada entrada activa cada salida: qué detectores hacen que los elevadores regresen, liberen puertas, apaguen ventiladores y activen determinados aparatos de notificación. Es el documento más útil para la puesta en servicio.",
    "nfpa": "7.3.3, 23.8",
    "topic": "Diseño",
    "aliases": [
      "secuencia de operaciones",
      "matriz de operaciones"
    ]
  }
};
